/**
 * Badge severity for a humanized `User#state` label, shared by every directory
 * table, drawer, and profile that renders one. Keep in step with
 * `UserLifecycleSnapshotPresenter::STATE_BADGE_VARIANTS`, which maps the same
 * lifecycle for the dashboard tile.
 *
 * @param {string | null | undefined} state Humanized state (e.g. "Onboarding requested")
 * @returns {"success" | "danger" | "info" | "neutral"}
 */
export function stateBadgeVariant(state) {
  if (state === "Active") return "success";
  if (state === "Inactive") return "danger";
  if (state === "Onboarding requested") return "info";
  if (state === "Offboarding requested") return "danger";

  return "neutral";
}
